document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  async function getFirebaseToken() {
    try {
      if (
        window.BFWT_Membership &&
        typeof window.BFWT_Membership.getCurrentUser === 'function'
      ) {
        const u = window.BFWT_Membership.getCurrentUser();
        if (u && typeof u.getIdToken === 'function') {
          return await u.getIdToken();
        }
      }
      if (
        window.BFWT_Membership &&
        typeof window.BFWT_Membership.getCurrentToken === 'function'
      ) {
        return window.BFWT_Membership.getCurrentToken() || '';
      }
    } catch (e) {
      console.warn('[BF Comments] Token resolve warning:', e);
    }
    return '';
  }

  // ── 1. Copy Referral Code Pill Handler ──
  document.body.addEventListener('click', async function (e) {
    const codeBadge = e.target.closest('.bfwt-comment-code-badge');
    if (!codeBadge) return;
    e.preventDefault();

    const code =
      codeBadge.getAttribute('data-code') || codeBadge.textContent.trim();
    if (!code) return;

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(code);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      window.BFWT_Toast?.success(`Referral code "${code}" copied to clipboard!`);
    } catch (err) {
      console.warn('Could not copy code:', err);
    }
  });

  // ── 2. Open FitterPass Auth Modal Trigger ──
  document.body.addEventListener('click', function (e) {
    const authBtn = e.target.closest('[data-open-fitterpass-auth]');
    if (!authBtn) return;
    e.preventDefault();
    if (
      window.BFWT_Membership &&
      typeof window.BFWT_Membership.openAuthModal === 'function'
    ) {
      window.BFWT_Membership.openAuthModal('login', { trigger: 'article_discussion', article_title: (document.querySelector('h1')?.textContent || '').trim() });
    } else {
      const sheet = document.getElementById('accountSheet');
      if (sheet && window.sheetManager) {
        window.sheetManager.open(sheet);
      }
    }
  });

  // ── 3. Sync Member vs Guest UI on Brand "Codes by You" & Review Comments ──
  function syncAuthMode(user) {
    const isLogged = Boolean(user);
    const displayName =
      user && user.displayName && !user.displayName.includes('@')
        ? user.displayName
        : 'FitterPass Member';

    document.querySelectorAll('.bfwt-comment-user-name').forEach((el) => {
      el.textContent = displayName;
    });

    // Brand Community Codes Gate vs Form
    const ccGate = document.getElementById('bfwt-cc-guest-gate');
    const ccForm = document.getElementById('bfwt-community-code-form');
    if (ccGate && ccForm) {
      if (isLogged) {
        ccGate.classList.add('tw-hidden');
        ccGate.classList.remove('tw-flex');
        ccForm.classList.remove('tw-hidden');
        ccForm.classList.add('tw-flex');
      } else {
        ccGate.classList.remove('tw-hidden');
        ccGate.classList.add('tw-flex');
        ccForm.classList.add('tw-hidden');
        ccForm.classList.remove('tw-flex');
      }
    }

    // Review Comment Member vs Guest Mode
    const rcMemberBar = document.getElementById('bfwt-rc-member-bar');
    const rcGuestBanner = document.getElementById('bfwt-rc-guest-banner');
    const rcGuestFields = document.getElementById('bfwt-rc-guest-fields');
    const rcGuestOptin = document.getElementById('bfwt-rc-guest-optin-wrap');
    const rcSubmitLabel = document.getElementById('bfwt-rc-submit-label');
    const rcEmailInput = document.getElementById('bfwt-rc-guest-email');

    if (isLogged) {
      if (rcMemberBar) {
        rcMemberBar.classList.remove('tw-hidden');
        rcMemberBar.classList.add('tw-flex');
      }
      if (rcGuestBanner) rcGuestBanner.classList.add('tw-hidden');
      if (rcGuestFields) rcGuestFields.classList.add('tw-hidden');
      if (rcGuestOptin) rcGuestOptin.classList.add('tw-hidden');
      if (rcEmailInput) rcEmailInput.removeAttribute('required');
      if (rcSubmitLabel) rcSubmitLabel.textContent = 'Post Comment (+25 Pts)';
    } else {
      if (rcMemberBar) {
        rcMemberBar.classList.add('tw-hidden');
        rcMemberBar.classList.remove('tw-flex');
      }
      if (rcGuestBanner) rcGuestBanner.classList.remove('tw-hidden');
      if (rcGuestFields) rcGuestFields.classList.remove('tw-hidden');
      if (rcGuestOptin) rcGuestOptin.classList.remove('tw-hidden');
      if (rcEmailInput) rcEmailInput.setAttribute('required', 'required');
      if (rcSubmitLabel) {
        rcSubmitLabel.textContent = 'Verify Email & Post Comment';
      }
    }
  }

  if (
    window.BFWT_Membership &&
    typeof window.BFWT_Membership.getCurrentUser === 'function'
  ) {
    syncAuthMode(window.BFWT_Membership.getCurrentUser());
  }
  window.addEventListener('bfwt:authchange', function (e) {
    syncAuthMode(e.detail ? e.detail.user : null);
  });

  // ── 4. Brand "Codes by You" Load More, Vote & Submit ──
  const ccLoadMore = document.getElementById('bfwt-cc-load-more');
  if (ccLoadMore) {
    ccLoadMore.addEventListener('click', function () {
      document
        .querySelectorAll('.bfwt-cc-hidden')
        .forEach((el) => el.classList.remove('bfwt-cc-hidden', 'tw-hidden'));
      ccLoadMore.classList.add('tw-hidden');
    });
  }

  document.body.addEventListener('click', async function (e) {
    const voteBtn = e.target.closest('[data-cc-vote]');
    if (!voteBtn || voteBtn.disabled) return;
    e.preventDefault();

    const codeId = parseInt(voteBtn.getAttribute('data-cc-vote') || '0', 10);
    if (!codeId) return;

    voteBtn.disabled = true;
    try {
      const token = await getFirebaseToken();
      const headers = { 'Content-Type': 'application/json' };
      if (token) headers.Authorization = `Bearer ${token}`;

      const res = await fetch('/wp-json/app-api/v1/community-codes/vote', {
        method: 'POST',
        headers,
        body: JSON.stringify({ code_id: codeId }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        const countEl = voteBtn.querySelector('.bfwt-cc-vote-count');
        if (countEl) countEl.textContent = data.worked_count;
        if (data.is_worked_by_me) {
          voteBtn.classList.add('tw-border-accent', 'tw-text-accent');
        } else {
          voteBtn.classList.remove('tw-border-accent', 'tw-text-accent');
        }
        if (data.points_awarded > 0) {
          window.BFWT_Toast?.success(
            `+${data.points_awarded} FitterPass Points earned for verifying a referral code!`
          );
        }
      }
    } catch (err) {
      console.warn('[Codes by You] Vote error:', err);
    } finally {
      voteBtn.disabled = false;
    }
  });

  const ccForm = document.getElementById('bfwt-community-code-form');
  if (ccForm) {
    ccForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const submitBtn = document.getElementById('bfwt-cc-submit-btn');
      if (!submitBtn || submitBtn.disabled) return;

      const brandId = parseInt(ccForm.getAttribute('data-brand-id') || '0', 10);
      const codeInput = document.getElementById('bfwt-cc-code-input');
      const noteInput = document.getElementById('bfwt-cc-note-input');
      const promoCode = codeInput ? codeInput.value.trim() : '';
      const note = noteInput ? noteInput.value.trim() : '';

      const origHtml = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sharing Code...';

      try {
        const token = await getFirebaseToken();
        const headers = { 'Content-Type': 'application/json' };
        if (token) headers.Authorization = `Bearer ${token}`;

        const res = await fetch('/wp-json/app-api/v1/community-codes', {
          method: 'POST',
          headers,
          body: JSON.stringify({
            brand_id: brandId,
            promo_code: promoCode,
            note: note,
          }),
        });
        const data = await res.json();
        if (!res.ok || !data.success) {
          throw new Error(data.message || 'Could not share referral code.');
        }

        window.BFWT_Toast?.success(data.message || 'Referral code shared!');
        if (codeInput) codeInput.value = '';
        if (noteInput) noteInput.value = '';

        const listEl = document.getElementById('bfwt-community-codes-list');
        const emptyEl = document.getElementById('bfwt-community-codes-empty');
        const badgeEl = document.getElementById('bfwt-cc-count-badge');
        if (emptyEl) emptyEl.classList.add('tw-hidden');

        if (listEl && data.item) {
          const it = data.item;
          const liHtml = `
            <li class="bfwt-cc-item tw-bg-surface tw-border tw-border-accent/50 tw-rounded-card tw-p-4 md:tw-p-5 tw-flex tw-flex-col tw-gap-3" data-cc-id="${it.id}">
              <div class="tw-flex tw-items-start tw-justify-between tw-gap-3">
                <div class="tw-flex tw-items-center tw-gap-3 tw-min-w-0">
                  <div class="tw-w-10 tw-h-10 tw-rounded-full tw-overflow-hidden tw-shrink-0 tw-border tw-border-line/40 tw-flex tw-items-center tw-justify-center">
                    ${it.avatar_svg || ''}
                  </div>
                  <div class="tw-flex tw-flex-col tw-min-w-0">
                    <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
                      <strong class="tw-font-heading tw-text-sm tw-font-bold tw-text-ink">${escapeHtml(it.author)}</strong>
                      <span class="tw-inline-flex tw-items-center tw-gap-1 tw-text-[10px] tw-font-heading tw-font-bold tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-accent/12 tw-text-accent">
                        <span>${escapeHtml(it.level_badge)}</span>
                      </span>
                    </div>
                    <span class="tw-text-[11px] tw-text-tertiary">Shared Just now</span>
                  </div>
                </div>
                <button type="button" class="bfwt-comment-code-badge tw-inline-flex tw-items-center tw-gap-2 tw-px-3.5 tw-py-1.5 tw-rounded-xl tw-bg-accent/[0.10] tw-border tw-border-dashed tw-border-accent/60 tw-text-accent tw-font-mono tw-text-xs md:tw-text-sm tw-font-bold tw-cursor-pointer" data-code="${escapeHtml(it.promo_code)}">
                  <span>${escapeHtml(it.promo_code)}</span>
                </button>
              </div>
              <p class="tw-text-xs md:tw-text-sm tw-text-secondary tw-m-0 tw-leading-relaxed">${escapeHtml(it.note)}</p>
            </li>
          `;
          listEl.insertAdjacentHTML('afterbegin', liHtml);
          if (badgeEl) {
            badgeEl.textContent =
              String(parseInt(badgeEl.textContent || '0', 10) + 1);
          }
        }
      } catch (err) {
        window.BFWT_Toast?.error(err.message || 'Could not share referral code.');
      } finally {
        submitBtn.disabled = false;
        submitBtn.innerHTML = origHtml;
      }
    });
  }

  // ── 5. Review Comments: Sort, Helpful Upvote, Reply & Dual-Mode Submit ──
  document.body.addEventListener('click', function (e) {
    const sortBtn = e.target.closest('[data-rc-sort]');
    if (!sortBtn) return;
    e.preventDefault();

    const mode = sortBtn.getAttribute('data-rc-sort') || 'helpful';
    document.querySelectorAll('[data-rc-sort]').forEach((b) => {
      if (b === sortBtn) {
        b.classList.add('is-active', 'tw-bg-accent', 'tw-text-cream');
        b.classList.remove('tw-bg-transparent', 'tw-text-secondary');
      } else {
        b.classList.remove('is-active', 'tw-bg-accent', 'tw-text-cream');
        b.classList.add('tw-bg-transparent', 'tw-text-secondary');
      }
    });

    const listEl = document.getElementById('bfwt-rc-list');
    if (!listEl) return;
    const items = Array.from(listEl.children);
    items.sort((a, b) => {
      if (mode === 'helpful') {
        const ha = parseInt(a.getAttribute('data-helpful-count') || '0', 10);
        const hb = parseInt(b.getAttribute('data-helpful-count') || '0', 10);
        if (hb !== ha) return hb - ha;
      }
      const ca = a.getAttribute('data-created-at') || '';
      const cb = b.getAttribute('data-created-at') || '';
      return cb.localeCompare(ca);
    });
    items.forEach((li) => listEl.appendChild(li));
  });

  // Helpful Upvote on Review Comments
  document.body.addEventListener('click', async function (e) {
    const helpBtn = e.target.closest('[data-comment-helpful]');
    if (!helpBtn || helpBtn.disabled) return;
    e.preventDefault();

    const cid = parseInt(
      helpBtn.getAttribute('data-comment-helpful') || '0',
      10
    );
    if (!cid) return;

    const token = await getFirebaseToken();
    if (!token) {
      window.BFWT_Toast?.info(
        'Sign in to your free FitterPass account to upvote helpful tips and earn +2 points!'
      );
      return;
    }

    helpBtn.disabled = true;
    try {
      const res = await fetch('/wp-json/app-api/v1/comments/helpful', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ comment_id: cid }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        const countEl = helpBtn.querySelector('.bfwt-rc-helpful-count');
        if (countEl) countEl.textContent = data.helpful_count;
        const parentLi = helpBtn.closest('.bfwt-rc-item');
        if (parentLi) {
          parentLi.setAttribute('data-helpful-count', data.helpful_count);
        }
        if (data.is_helpful_by_me) {
          helpBtn.classList.add('tw-border-accent', 'tw-text-accent');
        } else {
          helpBtn.classList.remove('tw-border-accent', 'tw-text-accent');
        }
        if (data.points_awarded > 0) {
          window.BFWT_Toast?.success(
            `+${data.points_awarded} FitterPass Points earned for upvoting a helpful tip!`
          );
        }
      }
    } catch (err) {
      console.warn('[Review Comments] Helpful vote error:', err);
    } finally {
      helpBtn.disabled = false;
    }
  });

  // Reply to a Review Comment
  document.body.addEventListener('click', function (e) {
    const replyBtn = e.target.closest('.bfwt-rc-reply-btn');
    if (!replyBtn) return;
    e.preventDefault();

    const cid = replyBtn.getAttribute('data-reply-id') || '0';
    const author = replyBtn.getAttribute('data-reply-author') || 'Reader';
    const parentInput = document.getElementById('bfwt-rc-parent-id');
    const banner = document.getElementById('bfwt-rc-reply-banner');
    const authorSpan = document.getElementById('bfwt-rc-reply-author');
    const textarea = document.getElementById('bfwt-rc-content');

    if (parentInput) parentInput.value = cid;
    if (authorSpan) authorSpan.textContent = `@${author}`;
    if (banner) {
      banner.classList.remove('tw-hidden');
      banner.classList.add('tw-flex');
    }
    if (textarea) {
      textarea.focus();
      textarea.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  const cancelReplyBtn = document.getElementById('bfwt-rc-cancel-reply');
  if (cancelReplyBtn) {
    cancelReplyBtn.addEventListener('click', function () {
      const parentInput = document.getElementById('bfwt-rc-parent-id');
      const banner = document.getElementById('bfwt-rc-reply-banner');
      if (parentInput) parentInput.value = '0';
      if (banner) {
        banner.classList.add('tw-hidden');
        banner.classList.remove('tw-flex');
      }
    });
  }

  // Submit Review Comment (Member 1-Click OR Guest + Newsletter Verification)
  const rcForm = document.getElementById('bfwt-review-comment-form');
  if (rcForm) {
    rcForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const submitBtn = document.getElementById('bfwt-rc-submit-btn');
      const feedbackEl = document.getElementById('bfwt-rc-feedback-msg');
      if (!submitBtn || submitBtn.disabled) return;

      if (feedbackEl) {
        feedbackEl.classList.add('tw-hidden');
        feedbackEl.textContent = '';
      }

      const postId = parseInt(rcForm.getAttribute('data-post-id') || '0', 10);
      const parentId = parseInt(
        document.getElementById('bfwt-rc-parent-id')?.value || '0',
        10
      );
      const content =
        document.getElementById('bfwt-rc-content')?.value.trim() || '';
      const guestName =
        document.getElementById('bfwt-rc-guest-name')?.value.trim() || '';
      const guestEmail =
        document.getElementById('bfwt-rc-guest-email')?.value.trim() || '';
      const newsletterOptIn = Boolean(
        document.getElementById('bfwt-rc-newsletter-optin')?.checked
      );

      const origHtml = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';

      try {
        const token = await getFirebaseToken();
        const headers = { 'Content-Type': 'application/json' };
        if (token) headers.Authorization = `Bearer ${token}`;

        const payload = {
          post_id: postId,
          parent_id: parentId,
          content: content,
        };
        if (!token) {
          payload.guest_name = guestName;
          payload.guest_email = guestEmail;
          payload.newsletter_opt_in = newsletterOptIn ? 1 : 0;
        }

        const res = await fetch('/wp-json/app-api/v1/comments', {
          method: 'POST',
          headers,
          body: JSON.stringify(payload),
        });
        const data = await res.json();

        if (!res.ok || !data.success) {
          throw new Error(data.message || 'Could not post comment.');
        }

        const contentEl = document.getElementById('bfwt-rc-content');
        if (contentEl) contentEl.value = '';
        if (cancelReplyBtn) cancelReplyBtn.click();

        if (data.status === 'pending_verification') {
          window.BFWT_Toast?.success('Verification email sent! Please check your inbox.');
          if (feedbackEl) {
            feedbackEl.className =
              'tw-p-3.5 tw-rounded-xl tw-bg-accent/12 tw-border tw-border-accent/40 tw-text-xs tw-text-ink tw-leading-relaxed';
            feedbackEl.innerHTML = `<strong>Almost there!</strong> ${escapeHtml(data.message)}`;
          }
        } else if (data.comment) {
          window.BFWT_Toast?.success(data.message || 'Comment published!');
          const c = data.comment;
          const listEl = document.getElementById('bfwt-rc-list');
          const emptyEl = document.getElementById('bfwt-rc-empty');
          const countBadge = document.getElementById('bfwt-rc-count-badge');
          if (emptyEl) emptyEl.classList.add('tw-hidden');

          if (c.parent_id > 0) {
            const parentLi = document.getElementById(`comment-${c.parent_id}`);
            if (parentLi) {
              let repliesUl = parentLi.querySelector('.bfwt-rc-replies');
              if (!repliesUl) {
                repliesUl = document.createElement('ul');
                repliesUl.className =
                  'bfwt-rc-replies tw-list-none tw-m-0 tw-mt-1 tw-pl-4 md:tw-pl-6 tw-border-l-2 tw-border-line/50 tw-flex tw-flex-col tw-gap-3';
                parentLi.appendChild(repliesUl);
              }
              repliesUl.insertAdjacentHTML(
                'beforeend',
                `<li id="comment-${c.id}" class="tw-bg-paper/70 tw-border tw-border-accent/40 tw-rounded-xl tw-p-3.5 tw-flex tw-flex-col tw-gap-2">
                  <div class="tw-flex items-center tw-gap-2.5">
                    <div class="tw-w-7 tw-h-7 tw-rounded-full tw-overflow-hidden tw-shrink-0 tw-border tw-border-line/40">${c.avatar_svg || ''}</div>
                    <strong class="tw-font-heading tw-text-xs tw-font-bold tw-text-ink">${escapeHtml(c.author)}</strong>
                    <span class="tw-text-[9.5px] tw-font-heading tw-font-bold tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-accent/12 tw-text-accent">${escapeHtml(c.level_badge)}</span>
                    <span class="tw-text-[10px] tw-text-tertiary">· Just now</span>
                  </div>
                  <div class="tw-text-xs tw-text-secondary tw-leading-relaxed">${escapeHtml(c.content)}</div>
                </li>`
              );
            }
          } else if (listEl) {
            listEl.insertAdjacentHTML(
              'afterbegin',
              `<li id="comment-${c.id}" class="bfwt-rc-item tw-bg-surface tw-border tw-border-accent/40 tw-rounded-card tw-p-4 md:tw-p-5 tw-flex tw-flex-col tw-gap-3" data-comment-id="${c.id}" data-helpful-count="0" data-created-at="${escapeHtml(c.created_at)}">
                <div class="tw-flex tw-items-start tw-justify-between tw-gap-3">
                  <div class="tw-flex tw-items-center tw-gap-3 tw-min-w-0">
                    <div class="tw-w-10 tw-h-10 tw-rounded-full tw-overflow-hidden tw-shrink-0 tw-border tw-border-line/40">${c.avatar_svg || ''}</div>
                    <div class="tw-flex tw-flex-col tw-min-w-0">
                      <div class="tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
                        <strong class="tw-font-heading tw-text-sm tw-font-bold tw-text-ink">${escapeHtml(c.author)}</strong>
                        <span class="tw-inline-flex tw-items-center tw-gap-1 tw-text-[10px] tw-font-heading tw-font-bold tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-accent/12 tw-text-accent">${escapeHtml(c.level_badge)}</span>
                      </div>
                      <span class="tw-text-[11px] tw-text-tertiary">Just now</span>
                    </div>
                  </div>
                </div>
                <div class="tw-text-xs md:tw-text-sm tw-text-secondary tw-leading-relaxed">${escapeHtml(c.content)}</div>
              </li>`
            );
          }
          if (countBadge) {
            countBadge.textContent = String(
              parseInt(countBadge.textContent || '0', 10) + 1
            );
          }
        }
      } catch (err) {
        window.BFWT_Toast?.error(err.message || 'Could not post comment.');
        if (feedbackEl) {
          feedbackEl.className =
            'tw-p-3.5 tw-rounded-xl tw-bg-red-500/10 tw-border tw-border-red-500/30 tw-text-xs tw-text-red-500 tw-leading-relaxed';
          feedbackEl.textContent = err.message || 'Could not post comment.';
        }
      } finally {
        submitBtn.disabled = false;
        submitBtn.innerHTML = origHtml;
      }
    });
  }
});
